import { AbstractDocument, Timestampable, Untrackable } from '../../../abstract/Document';
import type { ISupplierAdminStats } from './stats.types';

@Timestampable
@Untrackable
export class AdminStats extends AbstractDocument<ISupplierAdminStats> {
  readonly collections = {};
}
